import { IconButtonProps, IconButtonSize, IconButtonVariant } from '@xemplo/icon-button';
import { DawnCross } from '@xemplo/icons';
import { BreakpointSize } from '@xemplo/style-constants';
import { useWindowResize } from '@xemplo/use-window-resize';

import * as S from './close-button.styles';

export const ModalCloseButtonTestId = {
  closeButton: 'modal-close-button',
};

export const ModalCloseButton = ({
  variant = IconButtonVariant.Default,
  ...rest
}: Readonly<IconButtonProps>) => {
  const isSmallView = useWindowResize().windowSize.width < BreakpointSize.mediumV2;
  return (
    <S.CloseButton
      naked
      data-testid={ModalCloseButtonTestId.closeButton}
      {...rest}
      size={isSmallView ? IconButtonSize.Medium : IconButtonSize.Small}
    >
      {isSmallView ? (
        <DawnCross width={24} height={24} />
      ) : (
        <DawnCross width={16} height={16} />
      )}
    </S.CloseButton>
  );
};
